import React, { useState } from 'react';

import { IonIcon } from '@ionic/react';
import { logoWhatsapp, chevronDown, close, send } from 'ionicons/icons';

import '../../theme/whatsappWidget.css';

const greeting = 'Come possiamo aiutarti? :)';

// Pulsante WhatsApp flottante con il fumetto per scrivere un messaggio alla farmacia
const WhatsappWidget = ({ options, desktop = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [openedAt, setOpenedAt] = useState(null);

  const phoneNumber = normalizePhoneNumber(options?.whatsapp_number);

  // Il pulsante è spento per default: si attiva dalle opzioni della dashboard
  if (options?.whatsapp_widget !== '1' || !phoneNumber) return null;

  // Apre o chiude il fumetto, segnando l'ora mostrata nel messaggio di benvenuto
  const toggle = () => {
    if (!isOpen) setOpenedAt(new Date());

    setIsOpen(!isOpen);
  };

  // Apre WhatsApp con il messaggio scritto: WhatsApp Web su desktop, l'app su mobile
  const sendMessage = (event) => {
    event.preventDefault();

    const text = encodeURIComponent(message.trim());
    const url = desktop
      ? `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${text}`
      : `https://wa.me/${phoneNumber}?text=${text}`;

    window.open(url, '_blank', 'noopener');
    setIsOpen(false);
  };

  return (
    <div className={`whatsapp-widget ${desktop ? 'whatsapp-widget-desktop' : ''}`}>
      {isOpen && (
        <div className="whatsapp-widget-popup" role="dialog" aria-label="Parliamo con WhatsApp">
          <div className="whatsapp-widget-header">
            <IonIcon icon={logoWhatsapp} className="whatsapp-widget-header-icon" />
            <span className="whatsapp-widget-header-title">Parliamo con WhatsApp</span>
            <button type="button" className="whatsapp-widget-header-close" onClick={toggle} aria-label="Chiudi">
              <IonIcon icon={chevronDown} />
            </button>
          </div>

          <div className="whatsapp-widget-body">
            <div className="whatsapp-widget-bubble">
              {options?.shop_name && <div className="whatsapp-widget-bubble-author">{options.shop_name}</div>}
              <div>{greeting}</div>
              <div className="whatsapp-widget-bubble-time">{formatTime(openedAt)}</div>
            </div>
          </div>

          <form className="whatsapp-widget-footer" onSubmit={sendMessage}>
            <input
              type="text"
              className="whatsapp-widget-input"
              placeholder="Scrivi un messaggio"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              autoFocus
            />
            <button
              type="submit"
              className="whatsapp-widget-send"
              disabled={!message.trim()}
              aria-label="Invia su WhatsApp"
            >
              <IonIcon icon={send} />
            </button>
          </form>
        </div>
      )}

      <button
        type="button"
        className={`whatsapp-widget-fab ${isOpen ? 'whatsapp-widget-fab-open' : ''}`}
        onClick={toggle}
        aria-label={isOpen ? 'Chiudi WhatsApp' : 'Scrivici su WhatsApp'}
      >
        <IonIcon icon={isOpen ? close : logoWhatsapp} />
      </button>
    </div>
  );
};

// Lascia solo le cifre e aggiunge il prefisso italiano ai numeri che non lo hanno
const normalizePhoneNumber = (phoneNumber) => {
  const digits = String(phoneNumber ?? '')
    .replace(/^\+/, '')
    .replace(/^00/, '')
    .replace(/\D/g, '');

  if (!digits) return '';

  return digits.length <= 10 ? `39${digits}` : digits;
};

// Ora nel formato HH:MM
const formatTime = (date) => {
  if (!date) return '';

  return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
};

export default WhatsappWidget;
